import Swal from "sweetalert2";
import "./CRMPostventaV2Procesos.css";

const escapeHtml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const getResponsibleName = (responsable) =>
  String(responsable?.nombre || responsable?.Nombre || responsable?.usuario || responsable?.Usuario || "").trim();

const getResponsibleId = (responsable) => responsable?.usuarioId ?? responsable?.UsuarioId ?? responsable?.id ?? responsable?.Id;

export const openAssignResponsibleDialog = async ({
  title = "Asignar responsable",
  responsables = [],
  currentResponsibleId = null,
  emptyText = "Todavia no hay responsables visibles para asignar.",
}) => {
  const options = responsables
    .map((responsable) => {
      const id = getResponsibleId(responsable);
      const name = getResponsibleName(responsable);
      const total = Number(responsable?.total ?? responsable?.Total ?? 0);

      if (!id || !name) {
        return null;
      }

      return {
        id: String(id),
        name,
        total: Number.isFinite(total) ? total : 0,
      };
    })
    .filter(Boolean)
    .sort((a, b) => a.name.localeCompare(b.name, "es", { sensitivity: "base" }));

  if (!options.length) {
    await Swal.fire(title, emptyText, "info");
    return null;
  }

  const selectedId = currentResponsibleId ? String(currentResponsibleId) : "";
  const rowsHtml = options
    .map((option) => {
      const checked = option.id === selectedId ? "checked" : "";
      const countLabel = option.total > 0 ? `${option.total} caso${option.total === 1 ? "" : "s"}` : "Sin casos activos";

      return `
        <label class="crm-v2-assign-option" data-search="${escapeHtml(`${option.name} ${countLabel}`.toLowerCase())}">
          <input type="radio" name="crm-v2-responsable" value="${escapeHtml(option.id)}" ${checked} />
          <span>
            <strong>${escapeHtml(option.name)}</strong>
            <small>${escapeHtml(countLabel)}</small>
          </span>
        </label>`;
    })
    .join("");

  const result = await Swal.fire({
    title,
    html: `
      <div class="crm-v2-assign-dialog">
        <input class="crm-v2-assign-search" type="search" placeholder="Buscar responsable..." autocomplete="off" />
        <div class="crm-v2-assign-options">${rowsHtml}</div>
      </div>`,
    customClass: {
      popup: "crm-v2-assign-popup",
      confirmButton: "crm-v2-assign-confirm",
      cancelButton: "crm-v2-assign-cancel",
    },
    buttonsStyling: false,
    showCancelButton: true,
    confirmButtonText: "Asignar",
    cancelButtonText: "Cancelar",
    focusConfirm: false,
    didOpen: () => {
      const popup = Swal.getPopup();
      const search = popup?.querySelector(".crm-v2-assign-search");
      const rows = Array.from(popup?.querySelectorAll(".crm-v2-assign-option") || []);

      search?.addEventListener("input", () => {
        const query = search.value.trim().toLowerCase();
        rows.forEach((row) => {
          row.hidden = query && !String(row.dataset.search || "").includes(query);
        });
      });

      search?.focus();
    },
    preConfirm: () => {
      const selected = Swal.getPopup()?.querySelector('input[name="crm-v2-responsable"]:checked');
      if (!selected?.value) {
        Swal.showValidationMessage("Selecciona un responsable.");
        return false;
      }

      return selected.value;
    },
  });

  return result.isConfirmed && result.value ? Number(result.value) : null;
};
